import qs from 'querystring'
import _ from 'lodash'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'
import * as tip from '../../../../../uis/tip/reduces'
import dateFormat from '../../../../../util/dateFormat'
import {referDomains, orderTypes, languages} from '../../../../../util/consts'

//constant
const API_PREFIX = '/order-copy'

const NAME_PREFIX = 'ORDER_COPY';

const DEFAULT_SIZE = 10

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_BEFORES_LIST = `${NAME_PREFIX}_RECEIVE_BEFORES_LIST`;

const RECEIVE_TECHS_LIST = `${NAME_PREFIX}_RECEIVE_TECHS_LIST`

const RECEIVE_AFTERS_LIST = `${NAME_PREFIX}_RECEIVE_AFTERS_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

const RECEIVE_SON = `${NAME_PREFIX}_RECEIVE_SON`

const RECEIVE_FLOW_DETAIL = `${NAME_PREFIX}_RECEIVE_FLOW_DETAIL`

const RECEIVE_BASE_INFO = `${NAME_PREFIX}_RECEIVE_BASE_INFO`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

export const RECEIVE_STATUS_DETAIL = `${NAME_PREFIX}_RECEIVE_STATUS_DETAIL`

function trimForm(formData) {
    const newFormData = {};
    Object.keys(formData).forEach(key=>{
        const value = formData[key];
        if (typeof(value) === 'string') {
            newFormData[key] = value.trim();
        } else {
            newFormData[key] = value;
        }
    })
    if (newFormData.id) {
        if (newFormData.aliwangwang) {
            newFormData.indexField = ['id', 'customerAdminName', 'aliwangwang', 'phone', 'email', 'domain', 'labels', 'copyUrl', 'anliTitle', 'anliKeywords', 'companyName'].map(key=>formData[key] || '').join('_');
        }
    } else {
        newFormData.indexField = ['aliwangwang', 'phone', 'email', 'domain', 'labels', 'copyUrl', 'companyName'].map(key=>formData[key] || '').join('_');
    }
    return newFormData;
}

//action
function getData(params, dispatch, form) {
    return http.post(`${API_PREFIX}/list?${qs.stringify(params)}`, form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            });
            if (data.data.list.length > 0) {
                http.post(`http://cn2.caihongjianzhan.com/api/admin/md/public/mmtgabx4484/project-checkdetails?name=${data.data.list.filter(item => !!item.customerAdminName).map(item => item.customerAdminName)}`)
                    .then(({list}) => {
                        dispatch({
                            type: RECEIVE_BASE_INFO,
                            data: list.reduce((prev, curr) => {
                                return {...prev, [curr.name]: curr}
                            }, {})
                        })
                    })
            }
            
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query).filter(item => !_.includes(['isOnlyShowMe'], item));
    keys.forEach(key=>{
        if (query[key]) {
            form.filters.push({
                "field": key,
                "operator": filterList.find(item=>item.value === key).operator,
                "value": query[key]
            })
        }
    })
    const userInfo = http.getUserInfo();
    console.info(userInfo)
    if (query.isOnlyShowMe) {
        form.filters.push({
            "logic": "or",
            "filters": [
                {"field": "accountId", "operator": "eq", "value": userInfo.user.id},
                {"field": "currentAccountId", "operator": "eq", "value": userInfo.user.id},
                {"field": "afterSalerId", "operator": "eq", "value": userInfo.user.id},
            ]
        })
    }
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {orderCopy: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size,
            sort: page.sort
        }
        const form = getFormData(query, filterList);
        getData(data, dispatch, form)
    };
}

export function add(formData) {
    return (dispatch, getState) => {
        formData.domain = formData.domain ? formData.domain.toLowerCase() : formData.domain;
        // formData.referDomain = window.location.host;
        return http.post(`${API_PREFIX}/add`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update(formData) {
    return (dispatch, getState) => {
        formData.domain = formData.domain ? formData.domain.toLowerCase() : formData.domain;
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
                dispatch(getStatusDetail());
                if (formData.status === '完成' && formData.customerAdminName) {
                    const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/online/${formData.customerAdminName}` : `http://127.0.0.1:3333/api/online/${formData.customerAdminName}`;
                    return http.get(url)
                        .then(() => {
                            console.info('上线了');
                        })
                        .catch(e => {
                            console.error(e);
                        })
                }
            })
    }
}

export function updateSingleField(formData) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${formData.id}`)
            .then((data) => {
                return http.post(`${API_PREFIX}/update/${formData.id}`, {...data.data, ...formData})
            })
    }
}

export function addSon(formData) {
    return (dispatch, getState) => {
        dispatch({type: RECEIVE_SON, son: {
            aliwangwang: `${formData.aliwangwang}(${formData.customerAdminName})`,
            phone: formData.phone,
            email: formData.email,
            isNeedBuyDomain: false,
            domain: '',
            domainMoney: 0,
            restOrderMoney: 0,
            buyYear: formData.buyYear,
            orderTime: dateFormat(new Date(), 'yyyy-MM-dd'),
            sendEmailTime: dateFormat(new Date(Date.now() + (7 * 24 * 3600 * 1000)), 'yyyy-MM-ddTHH:mm'),
            copyUrl: formData.copyUrl,
            serverAddress: '自动分配',
            wangzhanType: '自建后台',
            isAuto: false,
            referDomain: formData.referDomain,
        }})
        dispatch({type: SHOW_MODAL, key: 'son', id: formData.id})
    }
}
export function updateFtp(formData) {
    formData.domain = formData.domain ? formData.domain.toLowerCase() : formData.domain;
    formData.status = '完成';
    const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/ftp/${formData.customerAdminName}` : `http://127.0.0.1:3333/api/ftp/${formData.customerAdminName}`;
    return (dispatch, getState) => {
        return http.post(url, trimForm(formData))
            .then(() => {
                return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
                .then(() => {
                    dispatch({type: HIDE_MODAL})
                    dispatch(getList());
                    if (formData.status === '完成' && formData.customerAdminName) {
                        const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/online/${formData.customerAdminName}` : `http://127.0.0.1:3333/api/online/${formData.customerAdminName}`;
                        return http.get(url)
                            .then(() => {
                                console.info('上线了');
                            })
                            .catch(e => {
                                console.error(e);
                            })
                    }
                })
            })
    }
}

export function updateDelivery(formData) {
    formData.status = '等待验收';
    return (dispatch, getState) => {
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList());
            })
    }
}

export function updateTemp(formData) {
    const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/temp/${formData.customerAdminName}` : `http://127.0.0.1:3333/api/temp/${formData.customerAdminName}`;
    formData.customerTempDomain = formData.customerTempDomain.replace('jiaogeiwo.cn', formData.newDomain);
    formData.customerAdminUrl = formData.customerAdminUrl.replace('jiaogeiwo.cn', formData.newDomain);
    
    return (dispatch, getState) => {
        // return Promise.resolve()
        return http.post(url, trimForm(formData))
            .then(() => {
                return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
                .then(() => {
                    dispatch({type: HIDE_MODAL})
                    dispatch(getList())
                })
            })
    }
}

export function updateTranslate(formData) {
    const commonpath = `/api/translate-cn/${formData.customerAdminName}/${formData.tl}?type=${formData.type}`;
    const serverAddress = (formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')
    const url = process.env.NODE_ENV === 'production' ? 
        `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}${commonpath}` : 
        `http://127.0.0.1:3333${commonpath}`;
    
    return (dispatch, getState) => {
        return http.get(url)
            .then(() => {
                if (formData.type === 'update') {
                    return http.post(`http://${serverAddress}/api/config-sync/${formData.customerAdminName}`, {
                        items: [{label: "language", type: "text", value: formData.tl}]
                    })
                }
                return Promise.resolve();
            })
            .then(() => {
                dispatch({type: HIDE_MODAL})
            })
    }
}

export function updateAdmin(formData) {
    const serverAddress = (formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')
    const url = process.env.NODE_ENV === 'production' ? `http://${serverAddress}/api/customer-admin/${formData.customerAdminName}?serverAddress=${serverAddress}&orderType=${formData.orderType}` : `http://127.0.0.1:3333/api/customer-admin/${formData.customerAdminName}?serverAddress=${serverAddress}&orderType=${formData.orderType}`;
    
    return (dispatch, getState) => {
        return http.get(url)
            .then(() => {
                return http.post(`http://${serverAddress}/api/admin/md/public/${formData.customerAdminName}/user-register`, {
                    email: "test@qq.com",
                    name: "test",
                    password: "123456"
                })
                .then(() => {
                    return dispatch({type: HIDE_MODAL})
                });
            })
    }
}

export function updateKeyword(formData) {
    return (dispatch, getState) => {
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList());
            })
    }
}

export function stopStartWangZhan(formData, status) {
    const url = process.env.NODE_ENV === 'production' ? `http://${(formData.customerAdminUrl || '').replace(formData.customerAdminName + '.', '')}/api/www-status/${formData.customerAdminName}/${status}/${formData.customerAdminUrl.split('.')[1]}` : `http://127.0.0.1:3333/api/www-status/${formData.customerAdminName}/${status}/${formData.customerAdminUrl.split('.')[1]}`;
    
    return (dispatch, getState) => {
        return http.get(url)
            .then(() => {
                dispatch(tip.success(status + '成功'))
            })
    }
}

export function showUpdateModal(id, disabled = false) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id, disabled})
            })
    }
}
export function showFtpModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'ftp', id})
            })
    }
}
export function showDeliveryModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'delivery', id})
            })
    }
}

export function showSslModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'ssl', id})
            })
    }
}

export function showDelayModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'delay', id})
            })
    }
}

export function showSmsModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'sms', id})
            })
    }
}

export function showTempModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'temp', id})
            })
    }
}

export function showTranslateModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'translate', id})
            })
    }
}

export function showAdminModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'admin', id})
            })
    }
}

export function showKeywordModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'keyword', id})
            })
    }
}

export function showFlowModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/flow/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_FLOW_DETAIL, flowDetail: data.data})
                dispatch({type: SHOW_MODAL, key: 'flow', id})
            })
    }
}

export function showRefundModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'refund', id})
            })
    }
}

export function getStatusDetail() {
    return (dispatch,getState) => {
        const {orderCopy: {query}} = getState()
        return http.get(`${API_PREFIX}/status?isOnlyShowMe=${query.isOnlyShowMe}`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_STATUS_DETAIL,
                    data: (data.data || []).reduce((previous, current) => {
                        previous[current[0]] = current[1];
                        previous['全部'] = previous['全部'] + current[1]; 
                        return previous;
                    }, {'全部': 0})
                })
            })
    }
}

export function getBefores() {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/befores`)
            .then((data) => {
                console.info(data.data);
                dispatch({type: RECEIVE_BEFORES_LIST, data: {befores: data.data}})
            })
    }
}

export function getTechs() {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/techs`)
            .then((data) => {
                console.info(data.data);
                dispatch({type: RECEIVE_TECHS_LIST, data: {techs: data.data}})
                
            })
    }
}
export function getAfters() {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/afters`)
            .then((data) => {
                console.info(data.data);
                dispatch({type: RECEIVE_AFTERS_LIST, data: {afters: data.data}})
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE,
        sort: "createTime,desc"
    },
    total: 0,
    techs: [],
    afters: [],
    showModal: {
        add: false,
        delete: false,
        update: false,
        refund: false,
        flow: false,
        id: null,
        disabled: false
    },
    detail: {},
    flowDetail: {
        list: []
    },
    filterList: [
        {"name": "客户旺旺号", "componentType": "Text", "data": [], "isShow": false, "value": "aliwangwang", "operator": "contains"},
        {"name": "客户手机号", "componentType": "Text", "data": [], "isShow": false, "value": "phone", "operator": "contains"},
        {"name": "客户邮箱", "componentType": "Text", "data": [], "isShow": false, "value": "email", "operator": "contains"},
        {"name": "客户域名", "componentType": "Text", "data": [], "isShow": false, "value": "domain", "operator": "contains"},
        {"name": "证件类型", "componentType": "Select", "data": [{"name":"营业执照","value":"营业执照"},{"name":"身份证","value":"身份证"}], "isShow": false, "value": "cid_type", "operator": "eq"},
        {"name": "下单日期", "componentType": "Datetime", "data": [], "isShow": false, "value": "order_time", "operator": "eq"},
        {"name": "售前备注", "componentType": "Textarea", "data": [], "isShow": false, "value": "preSaleRemarks", "operator": "contains"},
        {"name": "开发备注", "componentType": "Textarea", "data": [], "isShow": false, "value": "codingRemarks", "operator": "contains"},
        {"name": "售后备注", "componentType": "Textarea", "data": [], "isShow": false, "value": "after_sale_remarks", "operator": "contains"},
        {"name": "订单状态", "componentType": "Select", "data": [{"name":"新增","value":"新增"},{"name":"域名注册中","value":"域名注册中"},{"name":"域名模板注册中","value":"域名模板注册中"},{"name":"建站中","value":"建站中"},{"name":"等待开发","value":"等待开发"},{"name":"开发中","value":"开发中"},{"name":"等待交付","value":"等待交付"},{"name":"交付中","value":"交付中"},{"name":"发送邮件中","value":"发送邮件中"},{"name":"等待域名解析","value":"等待域名解析"},{"name":"域名解析中","value":"域名解析中"},{"name":"等待域名所有人变更","value":"等待域名所有人变更"},{"name":"域名所有人变更中","value":"域名所有人变更中"},{"name":"完成","value":"完成"},{"name":"退款中","value":"退款中"},{"name":"退款审核","value":"退款审核"},{"name":"退款完成","value":"退款完成"},{"name":"过期未开发","value":"过期未开发"},{"name":"错误","value":"错误"}], "isShow": false, "value": "status", "operator": "eq"},
        {"name": "是否软件自动", "componentType": "Select", "data": [{"name":"是","value":false},{"name":"否","value":false}], "isShow": false, "value": "is_auto", "operator": "eq"},
        {"name": "技术人员", "componentType": "Text", "data": [], "isShow": false, "value": "currentAccountName", "operator": "eq", "hideCancelBtn": true},
        {"name": "售后人员", "componentType": "Text", "data": [], "isShow": false, "value": "afterSalerName", "operator": "eq", "hideCancelBtn": true},
        {"name": "模糊查询", "componentType": "Text", "data": [], "isShow": true, "value": "indexField", "operator": "contains", "hideCancelBtn": true},
        {"name": "来源", "componentType": "Select", "data": [{"name":"双德","value":"app.sungdell.com"},{"name":"纸圭","value":"zhigui.sungdell.com"}], "isShow": true, "value": "referDomain", "operator": "eq"},
        {"name": "尾款", "componentType": "Select", "data": [{"name":"未结清尾款","value":"0"}], "isShow": true, "value": "restOrderMoney", "operator": "neq"},
        {"name": "是否退款域名", "componentType": "Select", "data": [{"name":"是","value":true},{"name":"否","value":false}], "isShow": false, "value": "isRefundDomain", "operator": "eq"},
        {"name": "是否需要购买域名", "componentType": "Select", "data": [{"name":"是","value":true},{"name":"否","value":false}], "isShow": false, "value": "isNeedBuyDomain", "operator": "eq"},
        {"name": "订单类型", "componentType": "Select", "data": orderTypes, "isShow": false, "value": "orderType", "operator": "eq"},
    ],
    query: {
        status: '',
        isOnlyShowMe: http.isTechRole(),
        currentAccountName: '',
        afterSalerName: ''
    },
    statusDeatial: {},
    baseInfo: {}
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [RECEIVE_BEFORES_LIST]: (state, {data}) => {
        return {...state, ...data};
    },
    [RECEIVE_TECHS_LIST]: (state, {data}) => {
        return {...state, ...data}
    },
    [RECEIVE_AFTERS_LIST]: (state, {data}) => {
        return {...state, ...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id, disabled}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id, disabled}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: (value && value.trim) ? value.trim(): value}, page: {...initialState.page}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    },
    [RECEIVE_SON]: (state, {son}) => {
        return {...state, son}
    },
    [RECEIVE_FLOW_DETAIL]: (state, {flowDetail}) => {
        return {...state, flowDetail}
    },
    [RECEIVE_STATUS_DETAIL]: (state,{data}) => {
        return {...state, statusDeatial: {...data}}
    },
    [RECEIVE_BASE_INFO]: (state,{data}) => {
        return {...state, baseInfo: {...data}}
    },
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/order_copy/reducers/list.js